<button mat-icon-button [matMenuTriggerFor]="$any(menu)" (click)="preventSelection($event)"
        aria-label="More menu"
        class="horizontal-menu-element">
    <mat-icon>more_horiz</mat-icon>
</button>
<mat-menu #menu="matMenu">
    @if(showEdit) {
        <button mat-menu-item (click)="editItem($event)">
            <mat-icon>edit</mat-icon>
            <span>{{ 'ITEMS.SHOWCASE.EDIT_ITEM' | translate }}</span>
        </button>
    }
    @if(showCopy) {
        <button mat-menu-item (click)="copyItem($event)">
            <mat-icon>content_copy</mat-icon>
            <span>{{ 'ITEMS.SHOWCASE.COPY_ITEM' | translate }}</span>
        </button>
    }
    @if(showLabels) {
        <button mat-menu-item (click)="generateLabelsItem($event)">
            <mat-icon>document_scanner</mat-icon>
            <span>{{ 'ITEMS.SHOWCASE.GENERATE_LABELS' | translate }}</span>
        </button>
    }
    @if(showDelete) {
        <button mat-menu-item (click)="onRemoveSelected($event)">
            <mat-icon>delete_forever</mat-icon>
            <span>{{ 'ITEMS.SHOWCASE.DELETE_ITEM' | translate }}</span>
        </button>
    }
</mat-menu>
